import { calculateVolatilityValue } from 'pages/ValuationsAllocation/util';
import { MATURITY_ALIAS, VOLATILITY_SOURCE_ALIAS } from './constants';
import { TCells, TChanges } from './types';
import { PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX } from '../../guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { BackSolveTableData } from '../types';

const afterCellChanged = (changes: TChanges[], cells: TCells, rowConfig: any, tableData: BackSolveTableData) => {
  const { gpcApproaches } = tableData;
  changes.forEach(change => {
    const { cell, value } = change;
    const volatilityCell = cells.B5;
    if ([VOLATILITY_SOURCE_ALIAS, MATURITY_ALIAS].includes(cell.alias)) {
      const maturityCell = cells.B2;
      const volatilitySourceCell = cells.B4;

      const selectedApproach = gpcApproaches?.find(approach => {
        const approachId = approach.valuations_approach_gpc?.id ?? approach.panelId;
        return approachId === volatilitySourceCell?.value;
      });

      changes.push({ cell, value });
      if (selectedApproach) {
        const comparison = Number(maturityCell?.value);
        const volatilityValue = calculateVolatilityValue(
          comparison,
          selectedApproach,
          PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
          maturityCell.key as string
        );
        changes.push({ cell: volatilityCell, value: volatilityValue });
      }
    }
  });
  return changes;
};

export default afterCellChanged;
